import React from 'react'
import alexAvatar from 'assets/alex-small-alt.png'
import { styles } from './styles'

const IMAGE_URL =
  'https://cdn.sanity.io/images/wqmhlzkj/production/dedc781973fadc7304c4510da1a9afb3e3ee8040-1675x939.png'

const POST_URL = 'https://helply.com/blog/groove-is-now-helply'

export default function Callout() {
  return (
    <aside css={styles.callout}>
      <div css={styles.card}>
        <div css={styles.imageWrapper}>
          <img src={IMAGE_URL} alt="Groove is now Helply" loading="lazy" />
        </div>
        <div css={styles.body}>
          <div css={styles.eyebrow}>A note for Groove customers</div>
          <h2 css={styles.title}>Groove is now Helply</h2>
          <div css={styles.byline}>
            <img src={alexAvatar} alt="Alex Turnbull" css={styles.avatar} />
            <div css={styles.bylineText}>
              <span css={styles.bylineName}>Alex Turnbull</span>
              <span css={styles.bylineRole}>
                Founder, Helply (formerly Groove)
              </span>
            </div>
          </div>
          <p css={styles.lead}>
            What does this Helply thing actually mean for me? The short answer
            is nothing.
          </p>
          <p css={styles.paragraph}>
            Your account, data, and workflows are exactly as they were — no
            migration and your login still works.
          </p>
          <a
            href={POST_URL}
            target="_blank"
            rel="noopener noreferrer"
            css={styles.cta}
          >
            Read the full announcement
            <svg
              width="18"
              height="18"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M3.333 8h9.334M8.667 3.333 13.333 8l-4.666 4.667"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
      </div>
    </aside>
  )
}
